import { call, put } from 'redux-saga/effects';

import MenuApi from '../apis/menu';
import {
    conversationError,
    getAllConversationsSuccess,
    switchConversationSuccess
} from '../actions/menuActions';
import { apiRequestStart, apiRequestEnd } from '../actions/loadingState/loadingStateActions';
import {push} from "connected-react-router";

// localStorage value controlling browser-level login/logout
const setLocalStorageToken = () => localStorage.setItem('token', Math.random().toString(36).substring(7));

export function* getAllConversationsSaga(action) {
    const { type } = action;

    try {
        yield put(apiRequestStart(type));

        const response = yield call(MenuApi.getAllConversations);

        if (response && response.data && response.data.success) {

            // TODO - Seems like a utility function that should already exist.. thoughts?
            // Sort descending so conversations with the latest message are displayed first.
            // If there is no message timestamp, then it should be listed last.
            response.data.conversations.sort((a, b) =>  {
                var currentDttm = a.latestMessageDttm;
                var previousDttm = b.latestMessageDttm;
                if (currentDttm === previousDttm) {
                    return 0;
                }
                if (!currentDttm) {
                    return 1;
                }
                return currentDttm < previousDttm ? 1 : -1
            });

            yield put(getAllConversationsSuccess(response.data));
        } else {
            yield put(conversationError(response));
        }
    }
    catch (error) {
        console.error('Error calling getAllConversations!', error);
        yield put(conversationError(error.response));
    }
    finally {
        // end LoadingState
        yield put(apiRequestEnd(type));
    }
}

export function* switchConversationSaga(request) {
    try {
        // start LoadingState
        yield put(apiRequestStart(request.type));

        const { conversationHash } = request;
        const data = {
            conversationHash: conversationHash,
        };

        const response = yield call(MenuApi.switchConversation, data);

        if (response && response.data.success) {
            setLocalStorageToken();

            // TODO do we need to edit Sentry stats or redo conversation details here?
            // TODO clear messages list in reducer and chain getMessages call
            yield put(switchConversationSuccess(response));
            yield put(push(`/chat/${conversationHash}`));
        }
    }
    catch (error) {
        yield put(conversationError(error));
        console.error('Error switching conversation!', error);
    }
    finally {
        // end LoadingState
        yield put(apiRequestEnd(request.type));
    }
}
